import { useViewport } from '@nuvolo/nuux-theme/hooks/useViewport';
import React from 'react';
import If from '#/common/components/If';
import LocationDataGrid from '../LocationDataGrid';
import LocationList from '../LocationList';

const Locations: React.FC = () => {
  const { isDesktop } = useViewport();

  return (
    <>
      <If condition={isDesktop}>
        <LocationDataGrid />
      </If>
      <If condition={!isDesktop}>
        <LocationList />
      </If>
    </>
  );
};

export default React.memo(Locations);
